import React from 'react';
import { Spin } from 'clad';

const containerLoadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '60vh'
};

const itemLoadingStyle = {
    alignSelf: 'center'
};

const MaskLoading = ({ spinning }) => {
    return (
        <div style={containerLoadingStyle}>
            <div style={itemLoadingStyle}>
                <Spin spinning={spinning} tip={_('Loading data ...')} />
            </div>
        </div>
    );
};

export default MaskLoading;
